import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { newsTranslations } from '../data/translations/newsTranslations';

export default function NewsletterSignup() {
  const { language } = useLanguage();
  const t = newsTranslations[language].news;
  const [status, setStatus] = useState("idle");

  const handleSubscribe = () => {
    setTimeout(() => setStatus("success"), 150);
  };

  return (
    <>
      <iframe name="mailchimp_iframe" className="hidden" style={{ display: 'none' }} title="mailchimp_submit" />
      <div className="bg-surface border border-border rounded-[2rem] p-8 lg:p-14 w-full shadow-xl flex flex-col md:flex-row items-center justify-between gap-10 relative overflow-hidden group">
        <div className="absolute -inset-24 bg-gradient-to-r from-secondary/10 to-transparent blur-3xl transition-all duration-1000 opacity-50 group-hover:opacity-100" />
        <div className="relative z-10 w-full md:w-5/12">
          <h5 className="font-headline text-3xl font-extrabold text-primary mb-3 tracking-tight">
            {t.subscribeTitle}
          </h5>
          <p className="opacity-60 text-sm leading-relaxed">
            {language === 'en'
              ? "Get the latest updates in AI and health technology delivered straight to your inbox."
              : "Recibe las últimas novedades en IA y tecnología de la salud directamente en tu bandeja de entrada."}
          </p>
        </div>
        <div className="relative z-10 w-full md:w-7/12">
          {status === "success" ? (
            <div className="bg-green-500/10 border border-green-500/20 text-green-500 rounded-2xl px-6 py-5 font-medium flex items-center justify-center gap-3">
              <span className="material-symbols-outlined">check_circle</span>
              {t.subscribeSuccess}
            </div>
          ) : (
            <form
              action="https://intelimed.us3.list-manage.com/subscribe/post?u=eb60181dfdec4835d7a3f4fbf&id=eff0a8f5b6&f_id=00e445e2f0"
              method="POST"
              target="mailchimp_iframe"
              onSubmit={handleSubscribe}
              className="flex flex-col sm:flex-row gap-3 w-full"
            >
              <input
                name="EMAIL"
                className="flex-grow bg-background border border-border focus:border-secondary text-sm rounded-2xl px-6 py-5 text-on-background outline-none transition-all duration-300 placeholder:opacity-50 focus:ring-1 focus:ring-secondary/50 font-medium shadow-sm"
                placeholder={language === 'en' ? "Enter your email address" : "Ingresa tu correo electrónico"}
                type="email"
                required
              />
              <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                <input type="text" name="b_eb60181dfdec4835d7a3f4fbf_eff0a8f5b6" tabIndex="-1" value="" readOnly />
              </div>
              <button
                type="submit"
                className="bg-primary text-on-primary font-black text-sm uppercase tracking-widest px-8 py-5 rounded-2xl hover:bg-secondary hover:text-on-secondary transition-all duration-300 shadow-lg whitespace-nowrap"
              >
                {language === 'en' ? "Subscribe" : "Suscribirme"}
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
